import React from 'react';
import PropTypes from 'prop-types';
import { getCategoryLogo } from 'containers/WStorePage/WStoreUtils';
import ImageFadeComponent from 'components/ImageFadeComponent';
import PurpleW from 'resources/PurpleW.png';
import './QuestItemImage.css';

function QuestItemImage({ quest }) {
  const prizes = quest.prizes.prizes;
  let formattedPrizes = prizes.map(prize => ({
    alt: prize.name,
    url: getCategoryLogo(prize.category)
  }));

  const questImageUrl = quest.prizeDetails ? quest.prizeDetails.url : null;
  const questName = quest.prizeDetails ? quest.prizeDetails.name : 'N/A';

  return (
    <div className="quest-item-image">
      <img
        className="item-image"
        src={questImageUrl || PurpleW}
        alt={questName}
      />
      <ImageFadeComponent className="category-image" images={formattedPrizes} />
    </div>
  );
}

QuestItemImage.propTypes = {
  quest: PropTypes.shape({
    id: PropTypes.string,
    prizeDetails: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      description: PropTypes.string
    }),
    prizes: PropTypes.shape({
      prizes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          category: PropTypes.string
        })
      )
    })
  })
};

export default QuestItemImage;
